import { ToolsTranslations } from '@/lib/translations/types';
import { RoeRoaResult } from './types';

interface Props {
  result: RoeRoaResult;
  translations: ToolsTranslations['roeRoa'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const roePct = Math.round(result.roe * 100);
  const roaPct = Math.round(result.roa * 100);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-sm font-medium text-gray-700 mb-2">{translations.roeLabel}</div>
        <div className="w-full rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-lg">{roePct} %</div>
      </div>
      <div>
        <div className="text-sm font-medium text-gray-700 mb-2">{translations.roaLabel}</div>
        <div className="w-full rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-lg">{roaPct} %</div>
      </div>
    </div>
  );
}


